module.exports = __webpack_public_path__ + "img/top binding width.2cede62f.png";